import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import AdminSideBarButton from "@components/Sidebar/Admin/SidebarButton";

import "@fortawesome/fontawesome-free/css/all.min.css";
import { layoutUtils } from "@/utils/layoutUtils";

export const AdminLeftSidebar = ({ sidebarVisible }) => {
  const location = useLocation();
  const [activeButton, setActiveButton] = useState("Tableau de Bord");
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("Tableau de Bord")) {
      setActiveButton("Tableau de Bord");
    } else if (path.includes("Gestion des Utilisateurs")) {
      setActiveButton("Gestion des Utilisateurs");
    } else if (path.includes("Gestion des Sanctions")) {
      setActiveButton("Gestion des Sanctions");
    } else if (path.includes("Réclamations des Clients")) {
      setActiveButton("Réclamations des Clients");
    } else if (path.includes("Approbation des Contenus")) {
      setActiveButton("Approbation des Contenus");
    } else if (path.includes("Gestion des Rôles et Permissions")) {
      setActiveButton("Gestion des Rôles et Permissions");
    } else if (path.includes("Analyse et Reporting")) {
      setActiveButton("Analyse et Reporting");
    } else if (path.includes("Centre de Support")) {
      setActiveButton("Centre de Support");
    } else if (path.includes("requests")) {
      setActiveButton("Demandes de cadeaux");
    } else if (path.includes("gifts")) {
      setActiveButton("Gestion de Cadeaux");
    } else if (path.includes("factures")) {
      setActiveButton("Gestion de Factures");
    } else if (path.includes("Configuration de la facturation")) {
      setActiveButton("Gestion de Factures");
    }else if (path.includes("Informations Entreprise")) {
      setActiveButton("Informations Entreprise");
    }
  }, [location.pathname]);

  const handleButtonClick = (label) => {
    setActiveButton(label);
  };

  return (
      <div
          style={{
            background: "#00BED4",
            borderRadius: 16,
          }}
          className={`flex flex-col gap-3 p-4 h-fit transition-all ${
              sidebarVisible ? "basis-2/12" : "w-fit"
          }`}
      >
        {layoutUtils.sideBarButtons.admin.map(({ path, label, icon }) => (
            <Link key={path} to={path} className={"w-full"}>
              <AdminSideBarButton
                  expand={sidebarVisible}
                  label={label}
                  icon={icon}
                  active={activeButton === label}
                  onClick={() => handleButtonClick(label)}
              />
            </Link>
        ))}

        <div
            className={`w-full justify-center flex ${
                sidebarVisible ? "gap-2" : "flex-col"
            }`}
            style={{
              textAlign: "center",
              color: "whitesmoke",
              fontSize: 15,
              fontFamily: "revert",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
        >
          <span>©{currentYear}</span>{" "}
          <span>Tale{!sidebarVisible ? "" : ". All rights reserved"}</span>
          <br />
          <br />
        </div>
      </div>
  );
};
